import { adminApi } from './admin-api';
import type { AdminFilters, AdminOrganisation, AdminOrganisationDetail, ApiResponse, PaginatedResponse } from '@/types/admin.types';

export const adminOrganisationsService = {
  getAll: async (filters: AdminFilters = {}): Promise<PaginatedResponse<AdminOrganisation>> => {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.search) params.set('search', filters.search);
    if (filters.sortBy) params.set('sortBy', filters.sortBy);
    if (filters.sortOrder) params.set('sortOrder', filters.sortOrder);
    const response = await adminApi.get(`/admin/organisations?${params.toString()}`);
    return response.data;
  },

  getById: async (uuid: string): Promise<ApiResponse<AdminOrganisationDetail>> => {
    const response = await adminApi.get(`/admin/organisations/${uuid}`);
    return response.data;
  },

  suspend: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/organisations/${uuid}/suspend`);
    return response.data;
  },

  activate: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/organisations/${uuid}/activate`);
    return response.data;
  },

  deleteOrganisation: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.delete(`/admin/organisations/${uuid}`);
    return response.data;
  },

  updatePlan: async (uuid: string, plan: string): Promise<{ message: string }> => {
    const response = await adminApi.patch(`/admin/organisations/${uuid}/plan`, { plan });
    return response.data;
  },
};
